import React from 'react';
import { ArrowRight } from 'lucide-react';

const HeroSection = ({
  title,
  subhead,
  ctaPrimary,
  ctaSecondary,
  trustLine,
  onPrimary,
  onSecondary,
  media
}) => {
  return (
    <section className="pt-32 pb-24 lg:pt-40 lg:pb-32" id="hero">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:gap-20 lg:items-center">
          <div className="text-center lg:text-left">
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-stone-900 leading-[1.1] max-w-[16ch] mx-auto lg:mx-0">
              {title}
            </h1>

            <p className="text-lg text-stone-500 mt-6 max-w-md mx-auto lg:mx-0">
              {subhead}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mt-10">
              <button
                onClick={onPrimary}
                className="bg-stone-900 text-white px-8 py-3.5 rounded font-medium hover:bg-stone-800 transition-colors inline-flex items-center justify-center group"
              >
                {ctaPrimary}
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
              </button>

              {ctaSecondary && (
                <button
                  onClick={onSecondary}
                  className="text-stone-500 hover:text-stone-900 px-8 py-3.5 font-medium transition-colors"
                >
                  {ctaSecondary}
                </button>
              )}
            </div>

            {trustLine && (
              <p className="text-xs text-stone-400 mt-8 text-center lg:text-left">
                {trustLine}
              </p>
            )}
          </div>

          {media && (
            <div className="mt-12 lg:mt-0">
              {media.type === 'video' && media.embedUrl ? (
                <div className="relative aspect-video rounded-lg overflow-hidden border border-stone-200">
                  <iframe
                    src={media.embedUrl}
                    title={media.alt || 'Demo video'}
                    className="absolute inset-0 w-full h-full"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    referrerPolicy="unsafe-url"
                  />
                </div>
              ) : media.type === 'video' && media.src ? (
                <video
                  className="w-full max-w-lg mx-auto rounded-lg border border-stone-200"
                  controls={media.controls !== false}
                  autoPlay={media.autoplay}
                  muted={media.muted}
                  loop={media.loop}
                  poster={media.poster}
                >
                  <source src={media.src} type="video/mp4" />
                  {media.webm && <source src={media.webm} type="video/webm" />}
                  Your browser does not support the video tag.
                </video>
              ) : (
                <img
                  src={media.src}
                  alt={media.alt}
                  className="w-full max-w-lg mx-auto rounded-lg border border-stone-200"
                />
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
